// Game inside NFT and NFT inside Game
import { useParams, Link as ReactLink } from 'react-router-dom';
import { ReactP5Wrapper } from '@p5-wrapper/react';
import { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import {
  VStack,
  Box,
  Button,
  HStack,
  List,
  ListItem,
  ListIcon,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Link,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Image,
} from '@chakra-ui/react';
import { IoIosFlower } from 'react-icons/io';
import {
  useWeb3ModalProvider,
  useWeb3ModalAccount,
} from '@web3modal/ethers5/react';
import { convertTimestampToDate } from '../../../../components/utils/helpers';
import getNetworkProvider from '../../../../walletConnections/obtainProviders/getNetworkProvider';
import getMagicFlowerDetail from '../../../../components/views/cozyGames/cozyGame1/magicFlowers/getMagicFlowerDetail';
import RenderMagicFlowerSketch from './RenderMagicFlowerSketch';
import GameFooter from '../../../../components/views/GameFooter';
import MagicFlowerTree from '../../../../components/sketches/games/magicFlowersSketches/plants/MagicFlowerTree';
import MagicGarden from '../../../../resources/images/games/magicflowers/magicgarden/3.png';
import DreamStudio from '../../../../resources/images/games/magicflowers/magicgarden/1.png';
import RenderMagicFlowerMeta from '../../../../components/views/cozyGames/cozyGame1/magicFlowers/RenderMagicFlowerMeta';

function MagicFlower() {
  const { address, chainId, isConnected } = useWeb3ModalAccount();
  // console.log('address:', address);
  // console.log('chainId:', chainId);
  // console.log('isConnected:', isConnected)
  const { walletProvider } = useWeb3ModalProvider();
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault(); // Prevent default behavior (scrolling)
        // Your game logic to shoot or perform actions here
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  const { magicflowerId } = useParams();
  // console.log('magicflowerId:', magicflowerId);

  const [magicFlowerOwner, setMagicFlowerOwner] = useState('');
  // const [genes, setGenes] = useState({});
  const [allGenes, setAllGenes] = useState([]);
  const [plantFeatures, setPlantFeatures] = useState({});
  const [evolvingPoints, setEvolvingPoints] = useState([]);
  const [displayTimePoint, setDisplayTimePoint] = useState(0);

  const [meta, setMeta] = useState({});
  const [nameMeta, setNameMeta] = useState({})
  const [userDefault, setUserDefault] = useState({});
  const [userDefaultBgs, setUserDefaultBgs] = useState([]);

  const [leaseDetail, setLeaseDetail] = useState({});

  useEffect(() => {
    getItem();
  }, []);

  const getItem = async () => {
    const provider =
      address == undefined
        ? getNetworkProvider()
        : new ethers.providers.Web3Provider(walletProvider);

    const data = await getMagicFlowerDetail(provider, magicflowerId);
    // console.log('data:', data);

    setMagicFlowerOwner(data.magicFlowerOwner);
    setUserDefault(data.userDefault);
    setUserDefaultBgs(data.userDefaultBgs);
    setNameMeta(data.nameMeta)
    setMeta(data.metadata);
    setPlantFeatures(data.plantFeatures);
    setAllGenes(data.allGenes);
    setDisplayTimePoint(data.displayTimePoint);
    setEvolvingPoints(data.evolvingPoints);

    setLeaseDetail(data.lease);
  };

  const RenderEvolvingPoints = () => {
    function generateRandomHexColor() {
      // Generate random integer between 0 and 16777215 (0xFFFFFF)
      var color = Math.floor(Math.random() * 16777215).toString(16);
      // Ensure that the hex color code is always 6 digits long
      return '#' + ('000000' + color).slice(-6);
    }
    if (Object.keys(allGenes).length > 0 && magicflowerId > 0) {
      return (
        <>
          <List spacing={3}>
            {allGenes.map((p, key) => {
              return (
                <ListItem key={key}>
                  <ListIcon
                    as={IoIosFlower}
                    w={6}
                    h={6}
                    color={generateRandomHexColor}
                  />
                  <Button
                    variant="outline"
                    onClick={() => setDisplayTimePoint(key)}
                  >
                    History at {convertTimestampToDate(p.timestamp)}
                  </Button>
                  {/* <Icon as={GiBackwardTime} w={6} h={6} color='teal.500'/> */}
                </ListItem>
              );
            })}
          </List>
        </>
      );
    }
  };

  const EvolvingHistoryButton = () => {
    return (
      <Accordion allowToggle>
        <AccordionItem>
          <h2>
            <AccordionButton>
              <Box textAlign="center">
                <Text
                  color="green.300"
                  fontSize="2xl"
                  style={{ fontFamily: 'Lobster' }}
                >
                  Details
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            <Tabs variant="soft-rounded" colorScheme="green">
              <TabList>
                <Tab>Plant Details</Tab>
                <Tab>Description</Tab>

              </TabList>
              <TabPanels>
                <TabPanel>
                  <RenderMagicFlowerMeta
                    meta={meta}
                    leaseDetail={leaseDetail}
                  />
                </TabPanel>
                <TabPanel>
                  <VStack>
                    <Box>{nameMeta.name}</Box>
                    <Box>{nameMeta.description}</Box>
                  </VStack>
                </TabPanel>
         
              </TabPanels>
            </Tabs>
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem>
          <h2>
            <AccordionButton>
              <Box textAlign="center">
                <Text
                  color="green.300"
                  fontSize="2xl"
                  style={{ fontFamily: 'Lobster' }}
                >
                  Evolving History
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            <RenderEvolvingPoints />
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    );
  };

  const ShowGalleryButton = ({ magicflowerId, magicFlowerOwner, name }) => {
    const myData = { magicFlowerOwner, name };
    const linkUrl = `/magicflowers/gallery/${magicflowerId}`;
    return (
      <Link as={ReactLink} to={linkUrl} state={myData}>
        <VStack>
          <Box boxSize={['158px', '198px']}>
            <Image src={MagicGarden} alt="Magic Garden" />
          </Box>
          <Text color="green.300" fontSize="3xl" as="b">
            Magic Garden
          </Text>
        </VStack>
      </Link>
    );
  };

  const MagicFlowerOwnerActionsButton = ({ magicflowerId }) => {
    const toLink = `/magicflowers/owneractions/${magicflowerId}`;
    return (
      <>
        <Link as={ReactLink} to={toLink}>
          <VStack>
            <Box boxSize={['158px', '198px']}>
              <Image src={DreamStudio} alt="Dream Studio" />
            </Box>
            <Text color="green.300" fontSize="3xl" as="b">
              Dream Studio
            </Text>
          </VStack>
        </Link>
      </>
    );
  };

  const RenderSketch = () => {
    return (
      <ReactP5Wrapper
        sketch={MagicFlowerTree}
        magicflowerId={magicflowerId}
        plantFeatures={plantFeatures}
        genes={allGenes[displayTimePoint]}
        userDefault={userDefault}
        userDefaultBgs={userDefaultBgs}
      />
    );
  };

  const RenderHybrid = () => {
    if (meta.isHybridization) {
      return <Text>Hybrid</Text>;
    } else {
      return <Text>Progenitor Plant</Text>;
    }
  };

  return (
    <>
      {magicflowerId > 0 && <RenderSketch />}
      {magicflowerId > 0 && <RenderMagicFlowerSketch flowerName={nameMeta.name} />}

      <VStack mt="18px" spacing={8}>
        <HStack spacing={5}>
          <Box>
            <EvolvingHistoryButton />
          </Box>
        </HStack>

        <HStack spacing="58px">
          <ShowGalleryButton
            magicflowerId={magicflowerId}
            magicFlowerOwner={magicFlowerOwner}
            name={meta.name}
          />

          {address == magicFlowerOwner && (
            <MagicFlowerOwnerActionsButton magicflowerId={magicflowerId} />
          )}
        </HStack>

        <div style={{ marginTop: '58px' }}>
          <GameFooter />
        </div>
      </VStack>
      <style jsx>
        {`
          @import url('https://fonts.googleapis.com/css?family=Lobster');
        `}
      </style>
    </>
  );
}

export default MagicFlower;
